<template>
    <div class="container-fluid">
        <div class="container">
            <div v-if="this.drugName == null">
                <div class="row">
                    <div class="col col-12">
                        <div class="text-center pt-4 pb-4">
                            <h1>GoodRx vs. IntelligentRx Coupons 2022</h1>
                        </div>
                    </div>
                </div>
                <div class="row pt-4">
                    <!-- <div
            class="col col-12 col-md-6 d-none d-md-block text-start grx-col pb-0"
          >
            <div class="grx-wrapper">
            <font-awesome-icon class="d-none d-md-block text-center pb-3" icon="fa fa-envelope" size="3x" aria-hidden="true"></font-awesome-icon>
              <h2 class="">GoodRx Has A Mail-Order Service</h2>
              <p>
                GoodRx provides a mail order service - another option to receive
                your prescription medications which IntelligentRx does not
                provide.
              </p>
            </div>
          </div> -->
                    <div class="col col-12 offset-md-3 col-md-6 text-start irx-col pb-0">
                        <div class="irx-wrapper">
                            <font-awesome-icon class="d-none d-md-block m-auto pb-3" icon="fa fa-dollar-sign"
                                style="color: green" size="3x" aria-hidden="true"></font-awesome-icon>
                            <h2 class="">
                                IntelligentRx Has Better Prices at Many Pharmacies
                            </h2>
                            <p>
                                IntelligentRx has better prices in 4 of the largest pharmacies
                                (including CVS and Walgreens).
                                <router-link to="/goodrx-comparison/#betterPrices">Learn more here</router-link>
                                or compare a price with our
                                <router-link to="/goodrx-comparison/#goodrx-comparison">price comparison tool</router-link>
                                or look
                                up any IntelligentRx price below.
                            </p>
                        </div>
                    </div>


                    <!-- <div class="col col-12 col-md-6 d-block d-md-none text-start grx-col">
            <div class="grx-wrapper">
              <font-awesome-icon
                class="d-none d-md-block m-auto pb-3"
                icon="fa fa-envelope"
                size="3x"
                aria-hidden="true"
              ></font-awesome-icon>
              <h2 class="">GoodRx Has A Mail-Order Service</h2>
              <p>
                GoodRx provides a mail order service - another option to receive
                your prescription medications which IntelligentRx does not
                provide.
              </p>
            </div>
          </div> -->
                    <div class="col col-12 col-md-6 text-start grx-col">
                        <div class="grx-wrapper">
                            <font-awesome-icon class="d-none d-md-block m-auto pb-3" icon="fa fa-circle-info" size="3x"
                                aria-hidden="true"></font-awesome-icon>
                            <h2 class="">GoodRx Has Better Drug Information</h2>
                            <p>
                                Medicare coverage (or lack thereof); Drug Info; Side Effects;
                                Images of the drugs: GoodRx has lots of resources to help you
                                learn more about a particular drug. IntelligentRx does not
                                provide any of these services; instead using a no-frills
                                approach to finding prescription savings.
                            </p>
                        </div>
                    </div>
                    <div class="col col-12 col-md-6 text-start irx-col">
                        <div class="irx-wrapper">
                            <font-awesome-icon class="d-none d-md-block m-auto pb-3" icon="fa fa-hospital-user" size="3x"
                                aria-hidden="true"></font-awesome-icon>
                            <h2 class="">IntelligentRx Is Better for Pharmacies</h2>
                            <p>
                                IntelligentRx charges pharmacies less, helping you save more.
                                <router-link to="/goodrx-comparison/#betterForPharmacies">Learn More</router-link>
                            </p>
                        </div>
                    </div>
                    <!-- <div class="col col-12 col-md-6 text-start grx-col">
            <div class="grx-wrapper">
              <font-awesome-icon
                class="d-none d-md-block m-auto pb-3"
                icon="fa fa-user-plus"
                size="3x"
                aria-hidden="true"
              ></font-awesome-icon>
              <h2 class="">GoodRx Provides A Membership Program</h2>
              <p>
                In exchange for a monthly fee, GoodRx can provide lower prices
                on some drugs. But buyer beware - many drugs have better prices
                outside of the discount program, even on GoodRx's own website.
              </p>
            </div>
          </div> -->
                    <!-- <div class="col col-12 col-md-6 text-start grx-col">
            <div class="grx-wrapper">
              <font-awesome-icon
                class="d-none d-md-block m-auto pb-3"
                icon="fa fa-user-doctor"
                size="3x"
                aria-hidden="true"
              ></font-awesome-icon>
              <h2 class="">GoodRx Has Provider Visits</h2>
              <p>
                GoodRx has purchased telehealth companies and integrated them
                into their platform, allowing you to pay out of pocket or with
                insurance for a health care visit.
              </p>
            </div>
          </div> -->
                    <div class="col col-12 col-md-6 text-start irx-col">
                        <div class="irx-wrapper">
                            <font-awesome-icon class="d-none d-md-block m-auto pb-3" icon="fa fa-rectangle-ad" size="3x"
                                aria-hidden="true"></font-awesome-icon>
                            <h2 class="">IntelligentRx Has No Ads</h2>
                            <p>
                                IntelligentRx does not have ads anywhere on its website or apps,
                                and we have no itention of adding any. GoodRx has a few
                                rectangular ad blocks served from Google Ads and also has
                                product placement, which tries to upsell you on various GoodRx
                                and partner services.
                            </p>
                        </div>
                    </div>
                    <div class="col col-12 col-md-6 text-start irx-col">
                        <div class="irx-wrapper">
                            <font-awesome-icon class="d-none d-md-block m-auto pb-3" icon="fa fa-tags" size="3x"
                                aria-hidden="true"></font-awesome-icon>
                            <h2 class="">IntelligentRx Can Show GoodRx Prices</h2>
                            <p>
                                We have catalogued and compared the most common GoodRx price in
                                its default label/form/dosage/quantity to the IntelligentRx
                                price in our GoodRx comparison to help you better understand the
                                different prices available.
                                <router-link to="/goodrx-comparison/#goodrx-comparison">Learn more</router-link>.
                            </p>
                        </div>
                    </div>
                    <div class="col col-12 col-md-6 text-start grx-col">
                        <div class="grx-wrapper">
                            <font-awesome-icon class="d-none d-md-block m-auto pb-3" icon="fa fa-building" size="3x"
                                aria-hidden="true"></font-awesome-icon>
                            <h2 class="">GoodRx has more than 12 PBMs</h2>
                            <p>
                                According to GoodRx's investor disclosures, they partner with
                                "more than 12" PBMs to provide the discount pricing you see on
                                their website. The PBMs are mostly traditional PBMs,
                                although GoodRx also uses some flat fee PBMs too.
                            </p>
                        </div>
                    </div>
                    <div class="col col-12 col-md-6 text-start irx-col">
                        <div class="irx-wrapper">
                            <font-awesome-icon class="d-none d-md-block m-auto pb-3" icon="fa fa-building" size="3x"
                                aria-hidden="true"></font-awesome-icon>
                            <h2 class="">IntelligentRx has 12 PBMs</h2>
                            <p>
                                IntelligentRx partners with exactly 12 PBMs to provide prices.
                                All of our PBMs were chosen because of their transparent nature
                                - they were willing to share how much money they make on
                                specific medications with us. We require this disclosure to
                                ensure they are passing prescription savings on to consumers.
                            </p>
                        </div>
                    </div>
                    <div class="col col-12 col-md-6 text-start grx-col">
                        <div class="grx-wrapper">
                            <font-awesome-icon class="d-none d-md-block m-auto pb-3" icon="fa fa-lock-open" size="3x"
                                aria-hidden="true"></font-awesome-icon>
                            <h2 class="">GoodRx sold Patient Data</h2>
                            <p>
                                GoodRx receives information like your name, sex, date of birth,
                                and the medication you are taking. They used this to
                                <a
                                    href="https://www.consumerreports.org/health-privacy/goodrx-saves-money-on-medsit-also-shares-data-with-google-facebook-and-others-a6177047589/">they
                                    share that information with third parties</a>
                                to advertise products to you based on your medical condition(s).
                                It is also possible that their PBM partners sell the data they
                                receive from pharmacies.
                            </p>
                        </div>
                    </div>
                    <div class="col col-12 col-md-6 text-start irx-col">
                        <div class="irx-wrapper">
                            <font-awesome-icon class="d-none d-md-block m-auto pb-3" icon="fa fa-lock" size="3x"
                                aria-hidden="true"></font-awesome-icon>
                            <h2 class="">IntelligentRx does Not Sell Your Data</h2>
                            <p>
                                IntelligentRx does not sell our data to anyone. That being said,
                                it is possible that our PBM partners sell the data they receive
                                from pharamcies.
                            </p>
                        </div>
                    </div>

                    <!-- <div
            v-for="(comparison, index) in this.pharmacyComparisons"
            :key="index"
            class="col col-12 col-md-6 py-2"
          >
            <div class="card">
              <div class="card-body">
                <h5 class="card-title">{{ comparison.PharmacyName }}</h5>
                <div>
                  <b style="font-size: 45px"
                    >{{ comparison.PercentageLower }}%</b
                  >
                </div>
                <p class="card-text">
                  {{ comparison.PercentageLower }}% of the time,
                  <b>IntelligentRx</b> has better prices than <b>GoodRx</b> at
                  <b>{{ comparison.PharmacyName }}</b> in a comparison of about
                  310 of the most commonly taken drugs
                </p>
              </div>
            </div>
          </div> -->
                    <!-- <div class="col col-12 text-center pt-3">
            <router-link class="btn irx-btn-primary btn-lg" to="/">
              Search IntelligentRx Prices
            </router-link>
          </div> -->
                </div>
            </div>
            <div v-else class="background-slanted-primary-negative-margin">
                <p>&nbsp;</p>
            </div>
        </div>

        <loading-spinner v-if="showSpinner" />

        <div class="background-slanted-primary text-light row pb-3">
            <div class="container">
                <div v-if="this.drugName == null">
                    <h2 id="betterPrices">How IntelligentRx has Better Prices</h2>
                    <p><b>Short answer:</b> We make less money.</p>
                    <p>
                        <b>Long answer:</b> Both GoodRx and IntelligentRx work by connecting
                        consumers to a third party called a PBM which issues prescription
                        discounts. This third party negotiates discounts and we help you get
                        access to those discounts. When you pay for a drug at a pharmacy
                        with a prescription discount coupon, part of the payment goes to the
                        pharmacy and part of the payment goes to the PBM. Both IntelligentRx
                        and GoodRx receive a cut of the PBM's payment when you use one of
                        our coupons. IntelligentRx can provide lower prices for the same
                        coupon because we receive a smaller cut than GoodRx. Unfortunately,
                        it's not as simple as, "IntelligentRx is always better because we
                        take a smaller cut". IntelligentRx and GoodRx's PBMs are different,
                        which means we have access to different discounts, which in turn
                        means sometimes GoodRx has access to better discount pricing than
                        IntelligentRx. We are always working to add more PBMs to get better
                        prices.
                    </p>
                    <p>
                        Our pricing analysis was conducted with about 310 of the highest
                        volume prescription drugs (~2% of high-volume drugs were excluded).
                        For each drug, we took a screenshot of GoodRx’s website and then
                        compared those prices to IntelligentRx prices. We found that
                        IntelligentRx has the better price X% of the time at different
                        pharmacies: 97% / Kroger; 71% / Walgreens; 66% / Rite Aid; 61% /
                        CVS; 47% / Walmart; 46% / Albertsons; 32% / Costco. Obviously, the
                        Kroger analysis is questionable due to the GoodRx-Kroger debacle,
                        but our savings at the biggest pharmacy chains - CVS and Walgreens -
                        and our prices at other pharmacies are superior or comparable.
                        Suffice to say, IntelligentRx’s prices are great! But there are
                        other reasons to use our service too.
                    </p>
                    <h2 id="betterForPharmacies">
                        How IntelligentRx is Better for Pharmacies
                    </h2>
                    <p><b>Short answer:</b> IntelligentRx Charges Pharmacies Less</p>
                    <p>
                        <b>Long answer:</b> GoodRx does not release data regarding how much
                        they charge pharmacies so we do not know their exact claim
                        information. However, we know our numbers and can share them with
                        you because we have transparent PBM contracts! Our most popular
                        discount (we have 12 PBM partners, so we'll focus on this one for
                        brevity) charges an average pharmacy <b>$3.45 per claim</b> if we get
                        paid. At CVS, our average paid claim is $27.25. We think GoodRx's
                        average paid claim is larger because they have worse prices, but I
                        digress. Let's assume GoodRx's PBMs are seeing average paid claims
                        of $27.25. GoodRx has stated on their public investor disclosures
                        that they receive 15% on most transactions, and drugchannels.net
                        suggests that the PBM might take 5%, so let's say 15% + 5% = 20% of
                        the paid claim goes to the PBM + GoodRx. With an average paid claim
                        of 27.25, pharmacies pay 27.25 * .2 = <b>$5.45 per claim</b>. What
                        does all this mean? Why should you care? We believe this means
                        IntelligentRx costs pharmacies 2 dollars less than GoodRx on a
                        typical prescription fill; therefore it's better for the pharmacies
                        to use IntelligentRx; and this helps IntelligentRx be accepted at
                        more pharmacies.
                    </p>

                </div>

                <div v-else>
                    <h1 class="text-center fw-bold pt-5" style="text-transform: capitalize">{{ drugName }} Price
                        Comparison</h1>
                    <p v-if="this.prices == null || this.prices.length < 1">
                        Sorry, but no up to date price comparison is available for
                        {{ drugName }} right now.
                    </p>
                    <div v-else>
                        <h2 v-if="drugNameInCoupons != null" class="text-center fw-bold"
                            style="text-transform: capitalize">
                            (prices for {{ drugNameInCoupons }})
                        </h2>
                        <div class="row d-md-flex d-none">
                            <div class="col col-3">
                                <h4 class="text-center">GoodRx</h4>
                            </div>
                            <div class="col col-3 offset-6">
                                <h4 class="text-center">IntelligentRx</h4>
                            </div>
                        </div>
                        <div class="row d-md-none d-flex">
                            <div class="col col-6">
                                <h4 class="text-start">GoodRx</h4>
                            </div>
                            <div class="col col-6">
                                <h4 class="text-start">IntelligentRx</h4>
                            </div>
                        </div>
                        <div class="row">
                            <div v-for="(price, index) in this.prices" :key="index" class="col col-12 py-1">
                                <div v-if="price.intelligentRx != null &&
                                    price.intelligentRx > 0 &&
                                    price.goodRx != null
                                    " class="row align-items-center">
                                    <a class="col col-3 text-center align-self-center" data-bs-toggle="modal"
                                        data-bs-target="#goodrxScreenshotModal" @click="
                                        screenshotSrc = price.goodRxScreenshot;
                                        screenshotURL = price.goodRxURL;
                                        " style="cursor: pointer">
                                        {{ price.goodRx > 0 ? price.goodRx : '?' }}
                                    </a>
                                    <div class="col col-6 align-self-center">
                                        <div>
                                            <div class="drug-name text-center text-light">
                                                {{ price.pharmacy }}
                                            </div>
                                        </div>
                                    </div>
                                    <button class="
                      col col-3
                      btn btn-light
                      comparison-drug-price
                      text-center
                    " @click="navigateToCoupon(price)" style="border-radius: 30px; font-weight: bold">
                                        ${{ price.intelligentRx }}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <button class="col col-8 my-2 btn btn-light" @click="navigateToSearch()"
                                style="border-radius: 30px; font-weight: bold">
                                See More Pharmacies
                            </button>
                            <button class="col col-12 col-md-8 my-2 btn btn-light" @click="navigateToSearch()"
                                style="border-radius: 30px; font-weight: bold">
                                Specify Label / Form / Dosage / Quantity
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <hr class="w-100" style="background-color: white" />

            <goodrx-comparison-links id="goodrx-comparison"></goodrx-comparison-links>
            <div class="container">
                <p class="pt-4">
                    These statistics are compiled for {{ this.numDrugsInComparison }} of
                    the most common drugs in their most common generic labels, forms,
                    dosages, and quantities. Drug costs are pulled from the IntelligentRx
                    and GoodRx websites. Drug prices change, so it is not possible to say
                    with certainty that IntelligentRx is always better than GoodRx. The
                    numbers seen here represent a snapshot of prices on IntelligentRx.com
                    and GoodRx.com when this report was created in July 2022.
                </p>
                <p>
                    Did you find this page helpful? If so,
                    <router-link to="/contact" class="light-link">please let us know!</router-link>
                </p>
            </div>
        </div>

        <!-- Modal for GoodRx Screenshots-->
        <div class="modal fade" id="goodrxScreenshotModal" tabindex="-1" role="dialog"
            aria-labelledby="goodrxScreenshotModalTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="goodrxScreenshotModalTitle"
                                            style="text-transform: capitalize">
                                            {{ drugName }}
                                        </h5>
                                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col col-12">
                                    <a :href="screenshotURL">Retrieved from GoodRx</a>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col col-12">
                                    <img class="img-fluid" :src="screenshotSrc"
                                        alt="Screenshot of GoodRx website showing prices for this drug" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script lang="ts">
import LoadingSpinner from "../controls/loading-spinner.vue";
import { requestmixin } from "../../mixins/requestmixin";
import { ipapimixin } from "../../mixins/ipapimixin";
import { mixinDetectingMobile } from "../../mixins/mixinDetectingMobile";
import { errormixin } from "../../mixins/errormixin";
import GoodrxComparisonLinks from "./goodrx-comparison-links.vue";
export default {
    name: "goodrx-comparison-page",
    data() {
        // let CVSPercentageLower = 61.5; // 171 / (171+107)
        let WalgreensPercentageLower = 71; // 147 / (147+60)
        // let WalmartPercentageLower = 47; // 108 / (108+118)
        // let CostcoPercentageLower = 32; // 90 / (90 + 187)
        let KrogerPercentageLower = 97; // 254 / (254 + 9)
        // let AlbertsonsPercentageLower = 46; // 84 / (84 + 99)
        // let RiteAidPercentageLower = 66; // 120 / (120 + 61)
        // let percentageLowerThreshold = 60;
        return {
            numDrugsInComparison: 310,
            /*
              From PriceComparisonPrice.cs:
              // ex: SAFEWAY PHARMACY
              public string Pharmacy { get; set; }
              // ex: 90
              public double Qty { get; set; }
              // ex: Tablet
              public string Form { get; set; }
              // ex: 40 MG
              public string Dosage { get; set; }
              // ex: ATORVASTATIN CALCIUM
              public string Ln { get; set; }
              // ex: 1-844-863-0353
              public string ServicePhone { get; set; }
              // ex: 1-888-807-9798
              public string HelpdeskPhone { get; set; }
              // ex: 003585
              public string RxBin { get; set; }
              // ex: 51802
              public string RxPcn { get; set; }
              // ex: 20211123
              public string MemberId { get; set; }
              // ex: ARX2002
              public string RxGroup { get; set; }
              public double IntelligentRx { get; set; }
      
              public double GoodRx { get; set; }
              public string GoodRxScreenshot { get; set; }
              */
            prices: [],
            drugName: this.$route.query.drugName,
            drugNameInCoupons: null,
            screenshotSrc: "",
            screenshotURL: "",
            showSpinner: false,
            //   IntelligentRxPercentageLower: 0,
            //   GoodRxPercentageLower: 0,
            pharmacyComparisons: [
                {
                    PharmacyName: "Kroger",
                    PercentageLower: KrogerPercentageLower,
                },
                {
                    PharmacyName: "Walgreens",
                    PercentageLower: WalgreensPercentageLower,
                },
                // {
                //     PharmacyName: "Rite Aid",
                //     PercentageLower: RiteAidPercentageLower,
                // },
                // {
                //     PharmacyName: "CVS",
                //     PercentageLower: CVSPercentageLower,
                // },
            ],
        };
    },
    components: {
        LoadingSpinner,
        GoodrxComparisonLinks,
    },
    mixins: [ipapimixin, requestmixin, mixinDetectingMobile, errormixin],
    methods: {
        navigateToSearch() {
            let encodedDrugName = this.drugName.replaceAll(" ", "+");
            this.$router.push({ path: "/" + encodedDrugName });
        },
        navigateToCoupon(price) {
            this.$router.push({
                name: "coupon-details-page",
                query: {
                    pharmacyName: price.pharmacy,
                    qty: price.qtyToDisplay,
                    form: price.form,
                    dosage: price.dosage,
                    ln: price.ln,
                    servicePhone: price.servicePhone,
                    helpdeskPhone: price.helpdeskPhone,
                    rxBin: price.rxBin,
                    rxPcn: price.rxPcn,
                    memberId: price.memberId,
                    rxGroup: price.rxGroup,
                    price: price.intelligentRx,
                    returnURL: encodeURIComponent(location.pathname + location.search),
                },
            });
        },
        loadPriceComparison() {
            if (this.drugName == null || this.drugName == "") {
                return;
            }
            this.toggleSpinner();
            this.get("/api/goodrx-price-comparison", {
                params: {
                    drugName: this.drugName,
                },
            })
                .then((res) => {
                    if (
                        res != null &&
                        res.errorHeading != null &&
                        res.errorMessage != null
                    ) {
                        console.error(res.errorHeading);
                        console.error(res.errorMessage);
                        return;
                    }
                    //   res.data = {"prices":[{"pharmacy":"CVS","qty":30,"form":"tablet ","dosage":"40","ln":"ATORVASTATIN CALCIUM","servicePhone":"1-800-407-8156","helpdeskPhone":"1-800-404-1031","rxBin":"006053","rxPcn":"MSC","memberId":"148914","rxGroup":"RX2002","intelligentRx":19.3800,"goodRx":30.26,"goodRxScreenshot":"/api/GoodRxScreenshotURL?drugName=ATORVASTATIN+CALCIUM","goodRxURL":"https://goodrx.com/atorvastatin","isRetailPrice":false},{"pharmacy":"KROGER","qty":30,"form":"tablet ","dosage":"40","ln":"ATORVASTATIN CALCIUM","servicePhone":"1-800-407-8156","helpdeskPhone":"1-800-404-1031","rxBin":"006053","rxPcn":"MSC","memberId":"148914","rxGroup":"RX2002","intelligentRx":9.4100,"goodRx":10.29,"goodRxScreenshot":"/api/GoodRxScreenshotURL?drugName=ATORVASTATIN+CALCIUM","goodRxURL":"https://goodrx.com/atorvastatin","isRetailPrice":false},{"pharmacy":"WALMART","qty":30,"form":"tablet ","dosage":"40","ln":"ATORVASTATIN CALCIUM","servicePhone":"1-800-407-8156","helpdeskPhone":"1-800-404-1031","rxBin":"006053","rxPcn":"MSC","memberId":"148914","rxGroup":"RX2002","intelligentRx":15.0,"goodRx":15.0,"goodRxScreenshot":"/api/GoodRxScreenshotURL?drugName=ATORVASTATIN+CALCIUM","goodRxURL":"https://goodrx.com/atorvastatin","isRetailPrice":true},{"pharmacy":"CVS INSIDE TARGET","qty":30,"form":"tablet ","dosage":"40","ln":"ATORVASTATIN CALCIUM","servicePhone":"1-800-407-8156","helpdeskPhone":"1-800-404-1031","rxBin":"006053","rxPcn":"MSC","memberId":"148914","rxGroup":"RX2002","intelligentRx":19.3800,"goodRx":30.26,"goodRxScreenshot":"/api/GoodRxScreenshotURL?drugName=ATORVASTATIN+CALCIUM","goodRxURL":"https://goodrx.com/atorvastatin","isRetailPrice":false},{"pharmacy":"COSTCO","qty":30,"form":"tablet ","dosage":"40","ln":"ATORVASTATIN CALCIUM","servicePhone":"1-800-407-8156","helpdeskPhone":"1-800-404-1031","rxBin":"006053","rxPcn":"MSC","memberId":"148914","rxGroup":"RX2002","intelligentRx":8.2500,"goodRx":10.25,"goodRxScreenshot":"/api/GoodRxScreenshotURL?drugName=ATORVASTATIN+CALCIUM","goodRxURL":"https://goodrx.com/atorvastatin","isRetailPrice":false},{"pharmacy":"RITE AID","qty":30,"form":"tablet ","dosage":"40","ln":"ATORVASTATIN CALCIUM","servicePhone":"1-844-863-0353","helpdeskPhone":"1-888-807-9798","rxBin":"003585","rxPcn":"51802","memberId":"148914","rxGroup":"ARX2002","intelligentRx":47.30,"goodRx":13.2,"goodRxScreenshot":"/api/GoodRxScreenshotURL?drugName=ATORVASTATIN+CALCIUM","goodRxURL":"https://goodrx.com/atorvastatin","isRetailPrice":false},{"pharmacy":"ALBERTSONS","qty":30,"form":"tablet ","dosage":"40","ln":"ATORVASTATIN CALCIUM","servicePhone":"1-800-407-8156","helpdeskPhone":"1-800-404-1031","rxBin":"006053","rxPcn":"MSC","memberId":"148914","rxGroup":"RX2002","intelligentRx":13.6400,"goodRx":6.51,"goodRxScreenshot":"/api/GoodRxScreenshotURL?drugName=ATORVASTATIN+CALCIUM","goodRxURL":"https://goodrx.com/atorvastatin","isRetailPrice":false}]}
                    this.prices = res.data.prices;
                    for (let i = 0; i < this.prices.length; i++) {
                        this.prices[i].intelligentRx = Number(
                            this.prices[i].intelligentRx
                        ).toFixed(2);
                        this.prices[i].goodRx = Number(this.prices[i].goodRx).toFixed(2);
                    }

                    // sort prices so that we see prices with the highest 'spread' in our favor first
                    this.prices = this.prices.sort(function compareFn(firstEl, secondEl) {
                        let firstElSpread = firstEl.goodRx - firstEl.intelligentRx;
                        let secondElSpread = secondEl.goodRx - secondEl.intelligentRx;
                        return secondElSpread - firstElSpread;
                    });

                    // if the returned coupons do not use the Drug Name we searched for, that information
                    // should be conveyed to users
                    if (this.prices != null && this.prices.length > 0 && this.prices[0].ln.toUpperCase() != this.drugName.toUpperCase())
                        this.drugNameInCoupons = this.prices[0].ln.toLowerCase();
                    else
                        this.drugNameInCoupons = null;
                })
                .catch(async (error) => {
                    if (error.response) {
                        // Server responded with non-2xx response
                        this.reportError(error.response.data);
                        this.reportError(error.response.status);
                        this.reportError(error.response.headers);
                        this.errorHeading = "Server Returned an Error";
                        // this.errorBody = await this.errorText();
                        this.showErrorCard = true;
                    } else if (error.request) {
                        // no response was received from request
                        this.reportError(error.request);
                        this.errorHeading = "No Response from Server";
                        // this.errorBody = await this.errorText();
                        this.showErrorCard = true;
                    } else {
                        // error setting up the request
                        this.reportError(error.message);
                        this.errorHeading = "Error Getting Drug Data";
                        // this.errorBody = await this.errorText();
                        this.showErrorCard = true;
                    }
                })
                .then(() => {
                    this.toggleSpinner();
                });
        },
        toggleSpinner() {
            this.showSpinner = !this.showSpinner;
        },
    },
    mounted() {
        let anchors = ["betterPrices", "betterForPharmacies", "goodrx-comparison", "goodrxScreenshotModal"];
        for (let i = 0; i < anchors.length; i++) {
            const anchor = anchors[i];
            if (document.location.hash === "#" + anchor) {
                setTimeout(() => {
                    document
                        .querySelector("#" + anchor)
                        .scrollIntoView({ behavior: "smooth", block: "start" });
                }, 300);
            }
        }

        // const urlParams = new URLSearchParams(document.location.search);
        // eslint-disable-next-line no-undef
        // amplitude.getInstance().logEvent("GRX_COMPARISON_PAGE_LOAD", {
        //   URL: document.location.toString(),
        //   ad: urlParams.get("ad"), // IRX AD ID
        //   gclid: urlParams.get("gclid"), // google click id
        // });

        // this path is taken on initial load
        if (this.drugName == null) {
            // default
            return;
        }
        this.loadPriceComparison();
    },
    watch: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        $route(to, from) {
            // this path is taken if you click on a link to another price comparison page
            this.drugName = this.$route.query.drugName;
            if (this.drugName == null) {
                // default
                return;
            }
            this.loadPriceComparison();
        }
    },
};
</script>

<style scoped>
.drug-name {
    text-align: left;
    font-size: 30px;
    font-weight: var(--header-font-weight);
    font-family: var(--header-font-family);
    letter-spacing: 0px;
    color: #292525;
    opacity: 1;
}

.comparison-drug-price {
    text-align: center;
    font-size: 20px;
    font-weight: var(--header-font-weight);
    font-family: var(--header-font-family);
    letter-spacing: 0px;
    opacity: 1;
}

.grx-col {
    padding-bottom: 30px;
}

.grx-wrapper {
    background-color: rgba(253, 234, 0, 0.4);
    height: 100%;
    width: 100%;
    padding: 20px;
    border-radius: 15px;
}

.irx-col {
    padding-bottom: 30px;
}

.irx-wrapper {
    background-color: var(--background-color-light-emphasis);
    height: 100%;
    width: 100%;
    padding: 20px;
    border-radius: 15px;
}

@media (max-width: 992px) {
    .drug-name {
        font-size: 26px;
        font-weight: var(--header-font-weight);
        font-family: var(--header-font-family);
    }

    .comparison-drug-price {
        font-size: 16px;
    }
}
</style>